// ---------------------------------------------------------------------------
// The app's session (R13)
//
// One instance for the app: client/startup.ts watches it and hands it to the
// session guard; signing out (sdr-router.ts) ends it. The logic is
// session.ts's.
// ---------------------------------------------------------------------------

import { createSession } from './session.js';

export const appSession = createSession();
